import script from "./TestCarte.vue?vue&type=script&setup=true&lang=js"
export * from "./TestCarte.vue?vue&type=script&setup=true&lang=js"

import "./TestCarte.vue?vue&type=style&index=0&id=e82de538&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e82de538"]])

export default __exports__